import { useCallback, useState } from "react";

/**
 * A remembered layout preference. The rail and the chat both collapse and both come back the
 * way they were left (docs/03). One key per workspace so two businesses can differ.
 */
export function usePref<T>(key: string, fallback: T): [T, (v: T) => void] {
  const [v, setV] = useState<T>(() => {
    try {
      const raw = localStorage.getItem(`joogoos:${key}`);
      return raw === null ? fallback : (JSON.parse(raw) as T);
    } catch {
      return fallback;
    }
  });
  const set = useCallback((next: T) => {
    setV(next);
    try { localStorage.setItem(`joogoos:${key}`, JSON.stringify(next)); } catch { /* private window */ }
  }, [key]);
  return [v, set];
}
